import { SessionUser } from '../utils/SessionUser';
import {
  createRouter,
  createWebHistory,
  RouteRecordRaw,
  RouteLocationNormalized,
} from 'vue-router';
import HomePage from '../pages/home/HomePage.vue';
import AccountRegister from '../pages/accountregister/AccountRegister.vue';
// import LoginPage from '../pages/login/login_v1/LoginPage.vue';
import LoginPage from '../pages/login/login_v2/LoginPage.vue';
import ContainsListPage from '../pages/list/ContainsListPage.vue';
import BlocklyPage from '../pages/blockly/BlocklyPage.vue';
import ExecutePage from '../pages/exec/ExecutePage.vue';
import EditUserPage from '../pages/admin/EditUserPage.vue';
import UserListPage from '../pages/admin/UserListPage.vue';
import modelUpload from '../pages/admin/3DmodelUpload.vue';
import FileManagerPage from '../pages/files/FileManagerPage.vue';
import RecoverBackupPage from '../pages/recover/RecoverBackupPage.vue';
import { MessageDialog } from '../../framework/frontend/MessageDialog';
import ClassMemberListPage from '../../frontend/pages/classroom/ClassMemberListPage.vue';
import ClassMemberContainsListPage from '../../frontend/pages/classroom/ClassMemberContainsListPage.vue';
import ClassPresentationPage from '../../frontend/pages/classroom/ClassPresentationPage.vue';
import CancelPage from '../../frontend/pages/payment/CancelPage.vue';
import SuccessPage from '../../frontend/pages/payment/SuccessPage.vue';
import CheckoutPage from '../../frontend/pages/payment/CheckoutPage.vue';
import ChangePlanPage from '../../frontend/pages/payment/ChangePlanPage.vue';
import WordToCanvasArPage from '../../frontend/pages/w2ar/WordToCanvasArPage.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: { requireAuth: false },
  },

  {
    path: '/account_register',
    name: 'AccountRegister',
    component: AccountRegister,
    meta: { requireAuth: false },
  },

  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
    meta: { requireAuth: false },
  },

  // 旧ログイン
  // {
  //   path: '/',
  //   name: 'LoginPage',
  //   component: LoginPage,
  //   meta: { requireAuth: false },
  // },

  {
    path: '/list',
    name: 'ListPage',
    component: ContainsListPage,
    meta: { requireAuth: true },
  },
  {
    path: '/blockly/:project_id',
    name: 'BlocklyPage',
    component: BlocklyPage,
    meta: { requireAuth: true },
  },
  {
    path: '/exec/:project_id',
    name: 'ExecutePage',
    component: ExecutePage,
    meta: { requireAuth: true },
  },
  {
    path: '/exec/:project_id',
    name: 'ExecutePage',
    component: ExecutePage,
    meta: { requireAuth: true },
  },
  {
    path: '/files/:project_id',
    name: 'FileManagerPage',
    component: FileManagerPage,
    meta: { requireAuth: true },
  },
  {
    path: '/recover/:project_id',
    name: 'RecoverBackupPage',
    component: RecoverBackupPage,
    meta: { requireAuth: true },
  },

  {
    path: '/edit_user/:user_id',
    name: 'EditUserPage',
    component: EditUserPage,
    meta: { requireAuth: true },
  },

  {
    path: '/user_list',
    name: 'UserListPage',
    component: UserListPage,
    meta: { requireAuth: true },
  },

  {
    path: '/word_to_canvas_ar/:project_id',
    name: 'WordToCanvasAr',
    component: WordToCanvasArPage,
    meta: { requireAuth: true },
  },

  {
    path: '/3dmodel_upload',
    name: '3DmodelUpload',
    component: modelUpload,
    meta: { requireAuth: true },
  },
  {
    path: '/class_room/:teacher_id/:class_name',
    name: 'ClassMemberListPage',
    component: ClassMemberListPage,
    meta: { requireAuth: false },
  },
  {
    path: '/class_list',
    name: 'ClassMemberContainsListPage',
    component: ClassMemberContainsListPage,
    meta: { requireAuth: true },
  },
  {
    path: '/presentation/:class_name',
    name: 'ClassPresentationPage',
    component: ClassPresentationPage,
    meta: { requireAuth: true },
  },

  {
    path: '/checkout',
    name: 'CheckoutPage',
    component: CheckoutPage,
    meta: { requireAuth: true },
  },
  {
    path: '/success',
    name: 'SuccessPage',
    component: SuccessPage,
    meta: { requireAuth: true },
  },
  {
    path: '/cancel',
    name: 'CancelPage',
    component: CancelPage,
    meta: { requireAuth: true },
  },
  {
    path: '/change_plan',
    name: 'ChangePlanPage',
    component: ChangePlanPage,
    meta: { requireAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to: RouteLocationNormalized, from, next) => {
  // console.log('routing', to.fullPath, to.meta, to.matched);

  // メタデータがなければnextに飛ばす（管理対象外のページ）
  to.meta ?? next();

  // 認証されていなければログイン画面出す
  // console.log('beforeEach', to.meta.requireAuth, SessionUser.isAuthorized, SessionUser.saveAuthUserInSession);
  if (to.meta.requireAuth) {
    if (!SessionUser.isAuthorized) {
      MessageDialog.info(`再度認証してください`);
      // console.log("fullPath", to.fullPath);
      next({ path: '/', query: { redirect: to.fullPath } });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
